/* eslint-disable camelcase */
import { createSelector } from 'reselect'
import { getCandidateProfile } from '../redux/modules/candidate'

export const wantsWorkInSouthAfrica = createSelector([getCandidateProfile], ({ remote_policies }) => {
  if (!remote_policies) return false

  return remote_policies.some(policy => policy.comprehensive_locations?.some(location => location.country_iso2_code.toLowerCase() === 'za'))
})

export const wantsRemoteWork = createSelector([getCandidateProfile], ({ remote_policies }) => {
  if (!remote_policies) return false

  return remote_policies.some(policy => policy.type.toLowerCase() === 'remote')
})

export const wantsWorkOutsideSouthAfrica = createSelector([getCandidateProfile], ({ remote_policies }) => {
  if (!remote_policies) return false

  return remote_policies.some(policy => policy.comprehensive_locations?.some(location => location.country_iso2_code.toLowerCase() !== 'za'))
})
